import React, { useState, useRef, useEffect } from 'react';
import { FaCog, FaDownload } from 'react-icons/fa';
import './Actions.css';

const Actions = ({ onImportClick, onDownloadTemplateClick }) => { // Add onDownloadTemplateClick as a prop
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Reference for the dropdown container

    // Event listener to close dropdown when clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div>
            {/* Dropdown */}
            <div className="actions-container" ref={dropdownRef}>
                <FaCog
                    className="actions-icon"
                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                />
                {isDropdownOpen && (
                    <div className="actions-dropdown-options">
                        <div onClick={onImportClick}> {/* Call the onImportClick prop */}
                            <FaDownload /> Import Records
                        </div>
                        <div onClick={onDownloadTemplateClick}> {/* Call the onDownloadTemplateClick prop */}
                            <FaDownload /> Download Import Template
                        </div>
                        {/* Add more options if needed */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Actions;